export default __webpack_public_path__ + "static/media/phone-colored.772d21f5.svg";